import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ListCandidatesService {

  private candidatesCountSource = new Subject<{req: boolean, count: number}>();

  candidatesCountChanged$ = this.candidatesCountSource.asObservable();

  changeCount(req: boolean, count: number) {
    this.candidatesCountSource.next({req: req, count: count});
  }
}




// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/list-candidates.service.ts